/*
 * Ledge mobile menu — open/close behaviour.
 *
 * Simpler than the cart drawer: single open/closed state, no cart:update
 * listener, no morphSection survival, no focus trap. Navigation menus
 * (per liquid-theme-a11y skill) use the `<nav>` + aria-expanded pattern,
 * not a modal/dialog pattern, so focus trap is explicitly out of scope.
 *
 * Triggered by the Menu button in the header. Dismissed by:
 *   - X close button in the overlay header
 *   - any nav link tap (navigation proceeds, overlay closes on its way out)
 *   - any legal / language link tap in the footer
 *   - Escape key
 *
 * Body scroll is NOT locked. The overlay is 100vw so there's no visible
 * content behind it to scroll into.
 *
 * Accessibility state we manage on open/close:
 *   trigger:   aria-expanded true|false
 *   overlay:   aria-hidden true|false, inert (when closed)
 * When closed, `inert` removes every descendant from the tab order and
 * the accessibility tree — this replaces the need for a focus trap.
 */
(function () {
  'use strict';

  function init(menu) {
    if (menu.dataset.ledgeInit === '1') return;
    menu.dataset.ledgeInit = '1';

    var trigger = menu.querySelector('[data-ledge-menu-trigger]');
    var overlay = menu.querySelector('.ledge-mobile-menu__overlay');
    if (!trigger || !overlay) return;

    function open() {
      menu.setAttribute('data-open', 'true');
      trigger.setAttribute('aria-expanded', 'true');
      overlay.setAttribute('aria-hidden', 'false');
      overlay.removeAttribute('inert');
    }

    function close() {
      menu.setAttribute('data-open', 'false');
      trigger.setAttribute('aria-expanded', 'false');
      overlay.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('inert', '');
    }

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      if (menu.getAttribute('data-open') === 'true') {
        close();
      } else {
        open();
      }
    });

    // Close buttons (X in header) — use delegation so we catch the SVG target too.
    menu.addEventListener('click', function (event) {
      var target = event.target;
      if (target.closest('[data-ledge-menu-close]')) {
        event.preventDefault();
        close();
        trigger.focus();
        return;
      }

      // Language switcher — submit the hidden localization form.
      var langLink = target.closest('[data-ledge-menu-lang]');
      if (langLink) {
        event.preventDefault();
        var code = langLink.getAttribute('data-locale-code');
        var input = menu.querySelector('[name="locale_code"]');
        var form = menu.querySelector('.ledge-mobile-menu__lang-form');
        if (input && form && code) {
          input.value = code;
          form.submit();
        }
        return;
      }

      // Any other link (primary, secondary, legal) — close AND let navigation happen.
      var link = target.closest('[data-ledge-menu-link]');
      if (link) {
        close();
        // Don't preventDefault — the browser follows the href.
      }
    });

    // Escape key closes when open.
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (menu.getAttribute('data-open') !== 'true') return;
      close();
      trigger.focus();
    });
  }

  function boot() {
    document.querySelectorAll('ledge-mobile-menu').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
